import * as React from 'react';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import { OutlinedInput } from '@mui/material';
import MenuItem from '@mui/material/MenuItem';
import { Translate } from '../../shared/LanguageService';

interface IFormSelectProps {
    label?: string;
    defaultTranslateKey?: string;
    autofocus?: boolean;
    defaultOptionValue?: any;
    children?: any;
}

const FormSelect = (props: IFormSelectProps) => {
    const { defaultTranslateKey, defaultOptionValue, label, ...rest } = props;
    const arrowStyle = { "& .MuiSelect-icon": { right: "12px", top: "50%", transform: "translateY(-50%)" } };

    return (
        <FormControl variant="outlined" fullWidth>
            <InputLabel id="select-label">{label}</InputLabel>
            <Select labelId="select-label" label={label} {...rest} sx={arrowStyle} input={<OutlinedInput label={label} />}>
                {props.defaultTranslateKey && (
                    <MenuItem value={props.defaultOptionValue ? props.defaultOptionValue : ''}>
                        {Translate(props.defaultTranslateKey)}
                    </MenuItem>
                )}
                {props.children}
            </Select>
        </FormControl>
    );
};

export default FormSelect;